import type { ReactNode } from 'react';

export const symbol_sync_saved_locally_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m805-231-60-60h69v-483H262l-60-60h612q24 0 42 18t18 42v483q0 26-20 44t-49 16Zm-65 106H70q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-185 70-185h610l-46-46H147q-24 0-42-18t-18-42v-487l-34-34q-9-9.27-9-21.64Q44-846 53-855t21.5-9q12.5 0 21.5 9L859-92q9 9 9 21t-9 21q-9 9-21.5 9T816-50l-76-75ZM574-291 147-718v427h427Zm-70-242Zm-143 28Zm127-43 98-98q9-9 21-8.5t21 9q9 8.5 9 20.97 0 12.46-9 21.53l-97 98-43-43Z"
		/>
	</svg>
);
